module.exports = __webpack_public_path__ + "img/activity64.f5a02649.png";